import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { BRAND, MEDIA } from "../lib/constants";

export default function CTABand({
  eyebrow = "Confidential Consultation",
  headline = "Protect the facility before pressure becomes a citation.",
  sub = "Most engagements begin with a 30 minute confidential review of the facility's most expensive operational risks. Schedule a strategic conversation with Sierra Thomas.",
  testId = "cta-band",
}) {
  return (
    <section
      className="relative overflow-hidden bg-navy text-ivory section-pad"
      data-testid={testId}
    >
      <div
        className="absolute inset-0 opacity-25"
        style={{
          backgroundImage: `url(${MEDIA.heroBg})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
        }}
      />
      <div className="absolute inset-0 bg-gradient-to-r from-navy via-navy/85 to-navy/40" />
      <div className="absolute top-0 left-0 right-0 h-px bg-gradient-to-r from-transparent via-gold to-transparent" />

      <div className="container-luxe relative z-10">
        <div className="max-w-3xl">
          <div className="overline mb-5">{eyebrow}</div>
          <h2 className="font-serif text-4xl sm:text-5xl lg:text-6xl leading-[1.05] text-ivory mb-6">
            {headline}
          </h2>
          <p className="font-sans text-lg text-ivory/75 max-w-2xl mb-10 leading-relaxed">
            {sub}
          </p>
          <div className="flex flex-col sm:flex-row gap-4">
            <a
              href={BRAND.calendlyUrl}
              target="_blank"
              rel="noopener noreferrer"
              className="btn-gold group"
              data-testid={`${testId}-book`}
            >
              Book a Confidential Consultation
              <ArrowRight className="h-4 w-4 group-hover:translate-x-1 transition-transform" />
            </a>
            <Link
              to="/services"
              className="inline-flex items-center justify-center gap-2 border border-ivory/30 text-ivory hover:border-gold hover:text-gold px-8 py-4 font-sans text-sm tracking-wide uppercase transition-colors"
              data-testid={`${testId}-services`}
            >
              Explore Services
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}
